// Client side of formatted notes. The server sanitises on write; this repeats the same allowlist before
// anything is shown or sent, so a note can only ever carry bold, italic and lists.
const ALLOWED = new Set(['b', 'strong', 'i', 'em', 'u', 'ul', 'ol', 'li', 'br', 'p', 'div']);
const SKIP = new Set(['script', 'style', 'iframe', 'object', 'embed', 'template']);

const escapeText = (s) => s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');

export const sanitizeNoteHtml = (html) => {
  if (!html) return '';
  const doc = new DOMParser().parseFromString(`<body>${html}</body>`, 'text/html');
  const walk = (node) => [...node.childNodes].map((c) => {
    if (c.nodeType === 3) return escapeText(c.nodeValue);
    if (c.nodeType !== 1) return '';
    const tag = c.tagName.toLowerCase();
    if (SKIP.has(tag)) return '';
    if (tag === 'br') return '<br>';
    return ALLOWED.has(tag) ? `<${tag}>${walk(c)}</${tag}>` : walk(c);
  }).join('');
  return walk(doc.body);
};

/** Plain text as editor HTML: escaped, one line break per newline. */
export const htmlFromText = (text) => escapeText(String(text || '')).replace(/\n/g, '<br>');

/** True when the editor HTML has visible text. */
export const hasNoteText = (html) => {
  const doc = new DOMParser().parseFromString(`<body>${html || ''}</body>`, 'text/html');
  return doc.body.textContent.trim().length > 0;
};
